import { StoreSelector } from '@provider-portal/mp2-common/components/StoreSelector/StoreSelector';
import {
  Availability,
  StoreListGroup,
} from '@provider-portal/mp2-common/components/StoreSelector/StoreSelectorStoresList';

export interface NavBarVenueSelectorProps {
  parentName: string;
  storeName: string;
  selectedStoreId: number;
  stores: StoreListGroup[];
  storeAvailabilities: Map<number, Availability>;
  storeAvailabilitiesLoading: boolean;
  showAddVenueButton?: boolean;
  onProviderSelect: (storeId: number) => void;
  onAddVenue: () => void;
  onSelectorOpen?: () => void;
  onSearchPerformed?: (searchQuery: string, resultsCount: number, searchCount: number) => void;
}

export function NavBarVenueSelector({
  parentName,
  storeName,
  selectedStoreId,
  stores,
  storeAvailabilities,
  storeAvailabilitiesLoading,
  showAddVenueButton = false,
  onAddVenue,
  onProviderSelect,
  onSelectorOpen,
  onSearchPerformed,
}: NavBarVenueSelectorProps) {
  const handleSelectStore = (storeId: number) => {
    onProviderSelect(storeId);
  };

  const handleSelectorOpen = () => {
    if (onSelectorOpen) {
      onSelectorOpen();
    }
  };

  const handleSearchPerformed = (
    searchQuery: string,
    resultsCount: number,
    searchCount: number,
  ) => {
    if (onSearchPerformed) {
      onSearchPerformed(searchQuery, resultsCount, searchCount);
    }
  };

  return (
    <StoreSelector
      parentName={parentName}
      storeName={storeName}
      stores={stores}
      storeAvailabilities={storeAvailabilities}
      storeAvailabilitiesLoading={storeAvailabilitiesLoading}
      selectedStoreId={selectedStoreId}
      onSelectStore={handleSelectStore}
      onAddVenue={onAddVenue}
      showAddVenueButton={showAddVenueButton}
      onSelectorOpen={handleSelectorOpen}
      onSearchPerformed={handleSearchPerformed}
    />
  );
}
